import { CSSProperties, ReactNode } from 'react';
import { useTableSorting } from '../hooks/useTableSorting';
import { TableHeaderCellContainer } from './styles';
import { TableSorting } from '../TableSorting/TableSorting';
import { Box } from '@/components/Box/Box';
import { TableHeaderVariantType } from '@/components/Table/TableHeader/TableHeader';

export type TextAlignType = CSSProperties['textAlign'];

type TableHeaderCellType = {
  name: string;
  variant?: TableHeaderVariantType;
  hasSort?: boolean;
  width?: string;
  textAlign?: TextAlignType;
  children?: ReactNode;
};

export const TableHeaderCell = ({
  width,
  name,
  hasSort,
  textAlign = 'left',
  variant = 'primary',
  children,
}: TableHeaderCellType) => {
  const { changeSorting, isAscendingSorting, isDescendingSorting, isUnsorted } = useTableSorting(name, hasSort);

  const sortTableData = () => {
    if (!hasSort) return;

    changeSorting();
  };

  return (
    <TableHeaderCellContainer
      hasSort={hasSort}
      width={width}
      onClick={sortTableData}
      variant={variant}
      textAlign={textAlign}
    >
      <Box display='inline-flex'>
        {children}
        {hasSort && (
          <TableSorting
            isAscendingSorting={isAscendingSorting}
            isDescendingSorting={isDescendingSorting}
            isUnsorted={isUnsorted}
          />
        )}
      </Box>
    </TableHeaderCellContainer>
  );
};
